export const downloadLocalFile = (url: string, filemame: string) => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filemame);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};
